import styled from 'styled-components';

import { GlobalToken } from 'antd';

export const Container = styled.div<{ theme: { token: GlobalToken } }>`
  display: block;
  text-align: center;
  margin: 0 ${({ theme: { token } }) => token.marginXS}px;

  &.collapsed {
    display: flex;

    .title-container .title {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
    }

    .value-container {
      width: auto;
      align-items: center;
      margin-left: ${({ theme: { token } }) => token.margin}px;
      .value {
        font-size: ${({ theme: { token } }) => token.fontSizeHeading2}px;
      }
      .unit {
        display: inline-block;
        font-size: ${({ theme: { token } }) => token.fontSize}px;
        text-align: center;
      }
    }
  }

  .title-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme: { token } }) => token.marginXS}px;

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .title {
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      color: ${({ theme }) => theme.token.colorText};
      text-transform: uppercase;
    }
  }
`;

interface ValueContainerProps {
  $vertical: boolean;
  $specialStyleKPIBox: boolean;
  $location: number;
  $valueLength: number;
  theme: { token: GlobalToken };
}

export const ValueContainer = styled.div<ValueContainerProps>`
  margin-top: ${({ theme: { token } }) => token.marginXXS}px;
  width: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .value-container-wrapper {
    display: flex;
    align-items: baseline;
    justify-content: center;
  }

  .border-bottom {
    width: 100%;
    height: 4px;
    background-color: ${({ theme }) => theme.token.colorBorder};
    border-radius: 10px;
  }

  .tier-span {
    display: inline-block;
    margin-top: ${({ theme: { token } }) => token.marginXXS}px;
    margin-left: ${({ theme: { token } }) => token.marginXXS}px;
  }
  .tier-wrapper {
    display: flex;
  }
  ${({ $vertical, theme: { token } }) =>
    $vertical &&
    `
    width: 100%;
    
    .value-container-wrapper {
      display: flex;
      align-items:center;
      flex-direction: column;
      margin-top: ${token.margin}px; 
      margin-bottom: ${token.marginXL}px;

      .unit {
        margin-left: 0;
        
        text-align: center;
      }
  }
`}

  .flex-tier {
    display: flex;
  }
  .value {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading1}px;
    color: ${({ theme: { token } }) => token.colorText};
  }

  .unit {
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    color: ${({ theme }) => theme.token.colorTextSecondary};
    margin-left: ${({ theme: { token } }) => token.marginXXS}px;
    text-align: center;
    display: flex;
  }

  ${({ $specialStyleKPIBox, $valueLength, $location }) =>
    $specialStyleKPIBox &&
    `
  width: fit-content;
  ${
    $valueLength
      ? `
  margin-left: clamp(0px, calc(${$location}% - ${($valueLength * 10) / 2}px), 500px);
  `
      : 'margin: 0 auto;'
  }
  margin-bottom: 0;

  .value {
    font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .unit {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    text-align: center;
    vertical-align: middle; 
   
  }
`}
`;

export const StyledBarPopover = styled.div`
  .bar-popover {
    .bar-popover-values {
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      font-size: ${({ theme: { token } }) => token.fontSize}px;
    }

    .bar-popover-unit {
      font-weight: normal;
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      padding-left: ${({ theme: { token } }) => token.paddingXXS}px;
    }
  }
`;

interface StyledRangeProps {
  $range: number;
  $color: string;
  $fadedColor: string;
  $isInRange: boolean;
}

export const StyledRange = styled.span<StyledRangeProps>`
  width: ${({ $range }) => $range}%;
  height: 4px;
  margin: 0 1px;
  background-color: ${({ $color }) => $color};
  border-radius: 10px;
  ${({ $isInRange, $fadedColor }) =>
    $isInRange &&
    `
    height: 7px;
    border: 2px solid ${$fadedColor};
    box-sizing: content-box;
    align-self: flex-end;
  `}

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

interface StyledScaleContainerProps {
  $specialStyleKPIBox: boolean;
  theme: { token: GlobalToken };
}

export const StyledScaleContainer = styled.div<StyledScaleContainerProps>`
  height: 10px;
  position: relative;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};

  ${({ $specialStyleKPIBox, theme: { token } }) =>
    $specialStyleKPIBox &&
    `
    background-color: ${token.colorBgElevated};
    border-radius: 1px;
    height: 15px;
  `}

  .bars {
    width: 100%;
    height: 6px;
    display: flex;

    .values-labels {
      position: relative;
      top: 6px;
      margin-top: ${({ theme: { token } }) => token.marginXXS}px;
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      color: ${({ theme }) => theme.token.colorTextSecondary};
      text-align: left;

      .max {
        position: absolute;
        right: 0;
      }
    }

    .in-range-value {
      margin-top: ${({ theme: { token } }) => token.marginXS}px;
    }
  }

  .disabled-bars {
    position: absolute;
    width: 100%;
    height: 6px;
    top: 12px;
    background-color: ${({ theme }) => theme.token.controlItemBgActiveDisabled};
    border-radius: 10px;
  }

  .margin-top {
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
  }

  .bar-value {
    font-weight: lighter;
  }

  .bar-unit {
    margin-left: ${({ theme: { token } }) => token.marginXXS}px;
    font-weight: lighter;
  }
`;

interface StyledTriangleProps {
  $location: number;
  $specialStyleKPIBox: boolean;
  theme: { token: GlobalToken };
}

export const StyledTriangle = styled.div<StyledTriangleProps>`
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid ${({ theme: { token } }) => token.colorText};
  position: relative;
  left: calc(${({ $location }) => $location}% - 6px);
  margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;

  ${({ $specialStyleKPIBox }) =>
    $specialStyleKPIBox &&
    `
  top: 4px;
`}
`;

interface StyledTargetCircleProps {
  $location: number;
  theme: { token: GlobalToken };
  $isTargetValueInRange: boolean;
}

export const StyledTargetCircle = styled.div<StyledTargetCircleProps>`
  width: ${({ $isTargetValueInRange }) => ($isTargetValueInRange ? '12px' : '10px')};
  height: ${({ $isTargetValueInRange }) => ($isTargetValueInRange ? '12px' : '10px')};
  border-radius: 50%;
  background-color: ${({ theme: { token } }) => token.colorSuccess};
  border: 1px solid ${({ theme: { token } }) => token.colorSuccessActive};
  position: absolute;
  left: calc(${({ $location }) => $location}% - 7px);
  top: ${({ $isTargetValueInRange }) => ($isTargetValueInRange ? '7px' : '9px')};
`;
